<template>
  <div class="tools02-conversion-api-test">
    <el-row>
      <el-col>
        <h2>コンバージョンAPI テスト送信</h2>
      </el-col>
    </el-row>
    <ConversionApiTestSystem :toolId="toolId" :accountId="accountId" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConversionApiTestSystem from "@/components/Tools02/ConversionApiTest/ConversionApiTestSystem.vue";

export default {
  components: {
    ConversionApiTestSystem,
  },
  props: {
    toolId: String,
    accountId: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rt"]),
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
